<template>
  <section class="features container">
    <div v-for="item in items" :id="item?.anchor_id ? item.anchor_id : null" class="features__Item">
      <div class="features__ItemTitles">
        <h2 :class="{'withoutSubtitle': !item.subtitle}">{{ item.title }}</h2>
        <h3 v-if="item.subtitle">{{ item.subtitle }}</h3>
      </div>

      <div v-if="getGalleryItems(item).length" class="features__ItemGallery">
        <div v-for="(image, index) in getGalleryItems(item).slice(0, 3)">
          <FlarePicture
            :src="{
              1920: { src: image.image || image, width: 644, height: 488, size: 'both', crop: 'fill' },
            }"
            :alt="image.image?.alt || image.alt"
          />
          <button v-if="index === 2 && getGalleryItems(item).length > 3" type="button" @click="openModal(item)">
            <div>
              <Icon name="gallery" />
            </div>
          </button>
        </div>
      </div>

      <div class="features__ItemTexts">
        <div v-if="item.rich_text_extended?.content_short" class="features__ItemShortText" v-html="item.rich_text_extended.content_short" />
        <div class="features__ItemExtendedTextWrapper" :class="{'isActive': item.extendedContentVisible}">
          <div v-if="item.rich_text_extended?.content" class="features__ItemExtendedText" v-html="item.rich_text_extended.content" />
        </div>
        <button v-if="item.rich_text_extended?.content && !item.page?.sef" class="button__Text--Underline" type="button" @click="item.extendedContentVisible = !item.extendedContentVisible">
          <template v-if="!item.extendedContentVisible">{{ $t('readMore') }}</template>
          <template v-else>{{ $t('readLess') }}</template>
        </button>
        <nuxt-link v-if="item.page?.sef" :to="item.page.sef" class="featureItem__TextsLink button__Text--Underline">{{ $t('readMore') }}</nuxt-link>
      </div>
    </div>

    <Modal v-show="dialogs.gallery" v-model="dialogs.gallery" class="modal__Gallery">
      <template v-for="item in modalData" :key="item.image?.id || item.id">
        <FlarePicture v-if="item"
          :src="{
            1920: { src: item.image || item, width: 1000 },
          }"
          :style="`color: ${getDominantColor(item.image || item)}`"
          :alt="item.image?.alt || item.alt"
        />
        <p v-if="item.description" v-text="item.description" />
      </template>
    </Modal>
  </section>
</template>

<script setup>
  const props = defineProps({
    data: {},
  });

  const dialogs = reactive({
    gallery: false
  });
  const { open } = useModal(dialogs);

  const items = ref(props.data.map(item => {
    return {
      ...item,
      extendedContentVisible: false
    }
  }));

  const modalData = ref(null);

  function openModal(item) {
    if (item.gallery?.items) modalData.value = item.gallery.items
    else modalData.value = item.gallery
    open('gallery');
  }

  function getGalleryItems(item) {
    return item.gallery?.items ? item.gallery.items : item.gallery;
  }
</script>

<style lang="scss">
  // @import url('@/assets/styles/components/blocks/_features.scss');
</style>